import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useRouteMatch, Switch, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import NewConsulttationList from "./NewConsulttationList.js";
import {
  getUserConsultations,
  getConsultationsTyeps,
  acceptNewConsultation,
  rejectNewConsultation,
} from "../../store/actions";
import "./NewConsultations.scss";
import AccountNotActivate from "../AccountNotActivate/AccountNotActivate";

const NewConsultations = ({
  consultant,
  getUserConsultations,
  getConsultationsTyeps,
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const { path } = useRouteMatch();
  const loaction = useLocation();
  useEffect(() => {
    getUserConsultations();
    getConsultationsTyeps();
  }, [getUserConsultations, getConsultationsTyeps]);
  useEffect(() => {
    const { loading, error, data } = consultant;
    setLoading(loading);
    setError(error);
  }, [consultant]);

  const renderView = () => {
    if (loading) {
      return "Loading ...";
    }
    if (error) {
      return "Error";
    }
    if (consultant.data) {
      return (
        <motion.div
          className="container-fluid Consultations"
          initial="out"
          animate="in"
          exit="out"
        >
          {consultant.data && consultant.data.verifiedAt ? (
            <AnimatePresence exitBeforeEnter>
              <Switch location={loaction} key={loaction.pathname}>
                <Route
                  exact
                  path={`${path}`}
                  component={NewConsulttationList}
                />
              </Switch>
            </AnimatePresence>
          ) : (
            <AccountNotActivate />
          )}
        </motion.div>
      );
    } else {
      return "";
    }
  };
  return renderView();
};
const mapStateToProps = (state) => {
  return {
    consultant: state.consultant,
  };
};
export default connect(mapStateToProps, {
  getUserConsultations,
  getConsultationsTyeps,
  acceptNewConsultation,
  rejectNewConsultation,
})(NewConsultations);
